const setResumeLlmPrompt = (llmPrompt) => ({
    type: 'SET_RESUME_LLM_PROMPT',
    llmPrompt,
});

export default setResumeLlmPrompt;
